import React, { Fragment, useEffect, useState } from "react";
import Dashboard from "../Admin/Dashboard/Dashboard";
import CurrentDate from "../Admin/CurrentDate";
import { useParams, Link, useNavigate } from "react-router-dom";
import Loader from "../Admin/Dashboard/Loader";
import axios from "axios";
import baseApi from "../api";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../../index.css";

const AddWebsiteSchema = (props) => {
  const [isLoading, setIsloading] = useState(false);
  const [webinar, setWebinar] = useState({});
  const [preview, setPreview] = useState();

  //   const { slug } = props.match.params;
  //   console.log("slug", slug);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      type: "",
      entityId: "",
      domain: "www.deaninfotech.com",
      schema:"",
      page: "global",
      isActive: true
    },
    validationSchema: Yup.object({
      type: Yup.string().required("Please enter page type"),
      entityId: Yup.string().required("Please enter entityId"),
      domain: Yup.string().required("Please enter domain"),
      schema: Yup.string().required("Please enter schema"),
      page: Yup.string().required("Please enter page"),
    }),
    onSubmit: (values) => {
      setIsloading(true);
      const formData = new FormData();
      formData.append("type", values.type);
      formData.append("entityId", values.entityId);
      formData.append("domain", values.domain);
      formData.append("schema", values.schema);
      formData.append("page", values.page);
      
      axios
        .post(
          `${baseApi}website-schema/`,
          {
            type: values.type,
            entityId: values.entityId,
            domain: values.domain,
            schema: JSON.parse(values.schema),
            page: values.page,
            domain: values.domain
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("jwtToken")}`
            }
          }
        )
        .then((res) => {
          setIsloading(false);
          setPreview("");
          formik.resetForm();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  });

  return (
    <Fragment>
      <div className="admin_panel">
        <Dashboard />

        {!isLoading ? (
          <div className="container">
            <div className="col-sm-12">
              {" "}
              <CurrentDate />
              <form onSubmit={formik.handleSubmit} encType="application/json">
                <div className="form-group">
                  <label>
                    <h3>Type</h3>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="type"
                    name="type"
                    {...formik.getFieldProps("type")}
                  />

                  <span className="text-danger">
                    {formik.touched.type &&
                    formik.errors.type ? (
                      <div>{formik.errors.type}</div>
                    ) : null}
                  </span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Entity Id</h3>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="entityId"
                    name="entityId"
                    {...formik.getFieldProps("entityId")}
                  />

                  <span className="text-danger">
                    {formik.touched.entityId && formik.errors.entityId ? (
                      <div>{formik.errors.entityId}</div>
                    ) : null}
                  </span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Domain</h3>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="domain"
                    name="domain"
                    {...formik.getFieldProps("domain")}
                  />

                  <span className="text-danger">
                    {formik.touched.domain &&
                    formik.errors.domain ? (
                      <div>{formik.errors.domain}</div>
                    ) : null}
                  </span>
                </div>

                
                <div className="form-group">
                  <label>
                    <h3>Page/Slug</h3>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="page"
                    name="page"
                    {...formik.getFieldProps("page")}
                  />

                  <span className="text-danger">
                    {formik.touched.page &&
                    formik.errors.page ? (
                      <div>{formik.errors.page}</div>
                    ) : null}
                  </span>
                </div>

                <div className="form-group">
                <label><h3>Schema</h3></label>

                <textarea
                  className="form-control"
                  name="schema"
                  rows="10"
                  placeholder="Enter schema here..."
                  {...formik.getFieldProps("schema")}
                />

                <span className="text-danger">
                  {formik.touched.schema && formik.errors.schema ? (
                    <div>{formik.errors.schema}</div>
                  ) : null}
                </span>
              </div>

                <hr />

                <div className="form-group">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Add Schema"
                  />
                  &nbsp;&nbsp;
                  <Link to="/website-schema">Back to website schema</Link>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </Fragment>
  );
};

export default AddWebsiteSchema;
